import React, { Component } from 'react';
import Header from './../common/Header';
import { Card, CardBody, Button } from 'reactstrap';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { fetchImages, imageSelection } from '../../actions/LeaderBoard/LeaderBoardAction';
import SearchInput, { createFilter } from 'react-search-input';
import moment from 'moment';
import Loader from './../common/Loader';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-daterangepicker/daterangepicker.css';

class Gallery extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            searchTerm: '',
            startDate: moment().startOf('isoweek'),
            endDate: moment().endOf('week'),
            ranges: {
                'This Week': [moment().startOf('isoweek'), moment().endOf('week')],
                'Last Week': [moment().subtract(1, 'week').startOf('isoweek'), moment().subtract(1, 'week').endOf('week')],
                'Week Before the Last': [moment().subtract(2, 'week').startOf('isoweek'), moment().subtract(2, 'week').endOf('week')]
            }
        };
        this.searchUpdated = this.searchUpdated.bind(this);
        this.handleApply = this.handleApply.bind(this);
    }

    componentDidMount() {
        setTimeout(() => this.setState({ loading: false }), 300);
    }

    onTouchImage(image) {
        this.props.imageSelection(image);
    }

    searchUpdated(term) {
        this.setState({ searchTerm: term });
    }

    handleApply(event, picker) {
        this.setState({
            startDate: picker.startDate,
            endDate: picker.endDate
        });
        const { users } = this.props;
        const start = this.state.startDate.format('YYYY-MM-DD').toString();
        const end = this.state.endDate.format('YYYY-MM-DD').toString();
        this.props.fetchImages(users, start, end);
    }

    renderUserImages() {
        const { users } = this.props;
        const filteredUsers = this.props.imageList.filter(createFilter(this.state.searchTerm, ['name', 'user_id']));

        return filteredUsers.map((image, index) => {
            return (
                <div className="col-xs-6 col-sm-3" style={{ paddingTop: 15 }} key={index}>
                    <Link to="/Campaign/Gallery/user_images" onClick={this.onTouchImage.bind(this, image, users)}>
                        <Card style={{ boxShadow: `0px 5px 15px 0px rgba(0,0,0,0.05)` }}>
                            <div style={{ backgroundImage: `url(${image.images[0].src})`, backgroundSize: 'cover', height: '200px' }} />
                            <CardBody style={{ height: '100px' }}>
                                <div className="row">
                                    <div className="col">
                                       <h6 style={{ fontFamily: 'Source Sans Pro-SemiBold' }}>{image.name}</h6>
                                       <h6 style={{ fontFamily: 'Source Sans Pro-SemiBold' }}>{image.user_id}</h6>
                                    </div>
                                    <div className="col" style={{ textAlign: 'right' }}>
                                        <span style={{ fontFamily: 'Source Sans Pro', color: '#9b9b9b' }}>
                                            {image.images.length} Images
                                        </span>
                                    </div>
                                </div>
                            </CardBody>
                        </Card>
                    </Link>
                </div>
            );
        });
    }

    renderFetchImages() {
        const { users } = this.props;
        const start = this.state.startDate.format('YYYY-MM-DD').toString();
        const end = this.state.endDate.format('YYYY-MM-DD').toString();
        this.props.fetchImages(users, start, end);
    }

    render() {
        const { loading } = this.state;
        const { imageList } = this.props;
        const start = this.state.startDate.format('DD-MM-YYYY').toString();
        const end = this.state.endDate.format('DD-MM-YYYY').toString();
        let label = start + ' to ' + end;
        if (start === end) {
            label = start;
        }
        return (
            <div style={{ overflowX: 'hidden', overflowY: 'hidden' }}>
                <Header />
                {
                    loading === true ? <Loader /> :
                        <div>
                            <div className="row" style={{ padding: 20, paddingBottom: 10 }}>
                                <div className="col" style={{ paddingTop: 4 }}>
                                    <Link to="/Campaign">
                                        <Button style={styles.galleryButtonStyle}>
                                            Back
                                        </Button>
                                    </Link>
                                </div>
                                <div className="col" style={styles.rowStyle}>
                                    <Card style={{ boxShadow: `0px 5px 15px 0px rgba(0,0,0,0.05)`, borderColor: '#7ed321' }}>
                                        {/* date picker */}
                                        <DateRangePicker
                                            ranges={this.state.ranges}
                                            startDate={this.state.startDate}
                                            endDate={this.state.endDate}
                                            onApply={this.handleApply}
                                        >
                                            <div className="input-group">
                                                <input type="text" className="form-control" value={label} readOnly style={styles.inputStyle} />
                                         <span className="input-group-btn" style={styles.spanStyle}>
                                             <Button className="default date-range-toggle" style={styles.buttonStyle}>
                                                 <i className="fa fa-calendar" />
                                             </Button>
                                         </span>
                                            </div>
                                        </DateRangePicker>
                                    </Card>
                                </div>
                            </div>
                            <div style={{ padding: 20 }}>
                                <Card style={{ padding: 25, boxShadow: `0px 1px 15px 5px rgba(0,0,0,0.05)`, borderColor: '#7ed321' }}>
                                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                        <SearchInput
                                            className="search-input"
                                            onChange={this.searchUpdated}
                                            style={styles.searchInputStyle}
                                        />
                                    </div>
                                    <div className="row" style={{ paddingTop: 10, paddingBottom: 10 }}>
                                        {
                                            imageList == '' ? this.renderFetchImages() :
                                                this.renderUserImages()
                                        }
                                    </div>
                                </Card>
                            </div>
                        </div>
                }
            </div>
        );
    }
}

const styles = {
    rowStyle: {
        paddingRight: 15,
        display: 'flex',
        justifyContent: 'center'
    },
    inputStyle: {
        backgroundColor: '#fff',
        color: '#808080',
        fontFamily: 'Source Sans Pro-SemiBold',
        textAlign: 'center',
        boxShadow: 'none'
    },
    spanStyle: {
        backgroundColor: '#44B31F',
        borderRadius: 0,
        border: '#ced4da'
    },
    buttonStyle: {
        backgroundColor: '#44B31F',
        borderRadius: 0,
        border: '#ced4da',
        boxShadow: 'none'
    },
    galleryButtonStyle: {
        fontFamily: "Source Sans Pro-SemiBold",
        backgroundColor: '#40b508',
        borderWidth: 0,
        boxShadow: `0px 1px 15px 5px rgba(0,0,0,0.05)`
    },
    searchInputStyle: {
        display: 'block',
        width: '100%',
        padding: '0.375rem 0.75rem',
        fontSize: '1rem',
        lineHeight: 1.5,
        color: '#495057',
        backgroundColor: '#fff',
        border: '1px solid #ced4da',
        borderRadius: '0.25rem'
    }
};

function mapStateToProps(state) {
    return {
        users: state.login.user,
        imageList: state.leaderBoardList.imageList
    };
}

export default connect(mapStateToProps, { fetchImages, imageSelection })(Gallery);



// WEBPACK FOOTER //
// ./src/components/Campaign/Gallery.js